// extracted by mini-css-extract-plugin
module.exports = {"modal_paper":"_3ywxSilZWJ1C","close":"CT8Nl2Wqb1-I"};